import { axiosInstance } from "api/axios-config/axios-config";
import { UpdateDimensionAndWeightRequest } from "api/models/request/product/dimension-and-weight";
import { UpdateMaterialRequest } from "api/models/request/product/material";
import {
  AddProduct,
  GetProducts,
  UpdateProduct,
} from "api/models/request/product/product";
import { DEFAULT_CATALOG_SLICE_SIZE } from "commons/constants";
import { OptionItem } from "commons/ultilities/dynamic-form/models/control";
import {
  createProductOptionLabel,
  createProductRenderOption,
} from "commons/ultilities/option-item/label-ultil";
import { IUpdateApproval } from "mobx-stores/_models/products/approval";
import { IUpdateManufactoring } from "mobx-stores/_models/products/manufactoring";
import { IProductProperties } from "mobx-stores/_models/products/product";
import { BaseBussiness } from "../base";

export class ProductBussiness extends BaseBussiness<
  IProductProperties,
  AddProduct,
  UpdateProduct,
  IProductProperties
> {
  url = "";
  constructor(url: string) {
    super(url);
    this.url = url;
  }
  public updateMaterial = async (
    productId: string,
    material: UpdateMaterialRequest,
  ) => {
    var res = await axiosInstance.put(
      `${this._url}/${productId}/material`,
      material,
    );
    return res.data;
  };

  public updateDimensionAndWeight = async (
    productId: string,
    dimentiosAndWeight: UpdateDimensionAndWeightRequest,
  ) => {
    var res = await axiosInstance.put(
      `${this._url}/${productId}/dimension-weight`,
      dimentiosAndWeight,
    );
    return res.data;
  };

  public updateApproval = async (
    productId: string,
    approval: IUpdateApproval,
  ) => {
    var res = await axiosInstance.put(
      `${this._url}/${productId}/approval`,
      approval,
    );
    return res.data;
  };

  public updateManufactoring = async (
    productId: string,
    manufactoring: IUpdateManufactoring,
  ) => {
    var res = await axiosInstance.put(
      `${this._url}/${productId}/process`,
      manufactoring,
    );
    return res.data;
  };

  public searchProductAsOptionItems = async (
    keyword: string,
    customerId?: string,
  ) => {
    const products = await this.getLists<GetProducts>({
      filter: keyword,
      maxResultCount: DEFAULT_CATALOG_SLICE_SIZE,
      skipCount: 0,
      sorting: "",
      customerId: customerId,
      isDisabled: false,
    });
    const itemOptions: OptionItem[] | undefined = products.items?.map((x) => ({
      value: x.id || "",
      label: createProductOptionLabel(x),
      renderOption: createProductRenderOption(x),
    }));
    return itemOptions || [];
  };

  public searchAllProducts = async (keyword: string) => {
    const products = await this.getLists<GetProducts>({
      filter: keyword,
      maxResultCount: DEFAULT_CATALOG_SLICE_SIZE,
      skipCount: 0,
      sorting: "",
      customerId: "",
      isDisabled: false,
      excludeDetail: true,
    });

    return products || [];
  };

  public uploadFile = async (productId: string, formData: FormData) => {
    var res = await axiosInstance.put(
      `${this._url}/${productId}/upload-file`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );
    return res.data;
  };

  public getFile = async (fileName: string) => {
    var res = await axiosInstance.get(`${this._url}/upload-file/${fileName}`, {
      responseType: "blob",
    });
    return res.data;
  };

  public deleteFile = async (fileName: string) => {
    var res = await axiosInstance.delete(
      `${this._url}/upload-file/${fileName}`,
    );
    return res.data;
  };

  public downloadFile = async (fileName: string) => {
    var res = await axiosInstance.get(
      `${this._url}/upload-file/download/${fileName}`,
      {
        responseType: "blob",
      },
    );
    return res.data;
  };
}

export const productBussiness = new ProductBussiness("/api/app/product");
